import {Auditoria} from "../../bibliotecaPjus/models/comum.models";
import {IFormulario, IModel} from "../../bibliotecaPjus/models/contrato.models";
import {AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from "@angular/forms";

export class NovoCalculoPropostaVencida extends Auditoria implements IModel, IFormulario {

  propostaId: string;
  profissao: string;
  telefoneCredor: string;
  emailCredor: string;
  motivo: string;

  form: FormGroup;

  constructor(other?: any) {
    super(other);
    if (other) {
      this.propostaId = other.propostaId;
      this.motivo = other.motivo;
    }
  }

  get asForm(): FormGroup {
    if (this.form == null) {
      this.form = new FormGroup({
        propostaId: new FormControl(this.propostaId),
        motivo: new FormControl(this.motivo, [Validators.required]),
      });
    }
    return this.form;
  }

  updateForm(other): void {
    this.form.patchValue(other);
  }
}

export function emailValidado(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const valid = emailRegex.test(control.value);
    return valid ? null : { invalidEmail: true };
  };
}
